import { checkAuthentication } from './middleware';
export const userRoutes = [
    {
        path: '/users',
        name: 'UserList',
        component:  () => import(/* webpackChunkName: "user-route" */ '../views/users/UserList'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/users/create',
        name: 'CreateUser',
        component: () => import(/* webpackChunkName: "user-route" */ '../views/users/CreateUser'),
        // props: true,
        beforeEnter: checkAuthentication
    },
    {
        path: '/users/:id',
        name: 'ViewUser',
        component: () => import(/* webpackChunkName: "user-route" */ '../views/users/ViewUser'),
        props: true,
        beforeEnter: checkAuthentication
    },

]